import { isAxiosError } from 'axios';

export default function getErrorMessage(error: any | any[]): string {
  if (Array.isArray(error)) return getErrorMessage(error[0]);

  if (typeof error === 'string') return error;

  if (typeof error === 'number') return error.toString();

  if (isAxiosError(error)) {
    // try to get the error message from the response
    const axiosErrorMessage = error.response?.data?.details
      ?? error.response?.data?.message
      ?? error.response?.data?.error
      ?? error.response?.data;

    if (axiosErrorMessage) {
      return axiosErrorMessage;
    }
    return error.message;
  }

  if (error?.message && typeof error.message === 'string') {
    return error.message;
  }

  if (error instanceof Error) {
    return error.message || error.toString();
  }

  if (error?.request) return 'REQUEST_ERROR';

  if (error?.description) return error.description;

  return 'UNKNOWN';
}
